import { render, staticRenderFns } from "./PublisherContentComponent.vue?vue&type=template&id=0a93a9d0"
import script from "./PublisherContentComponent.vue?vue&type=script&lang=ts"
export * from "./PublisherContentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports